import { useNavigate } from 'react-router-dom';
import { useRoutesProvider } from '../../../providers/provider-hooks';
import { Button } from '../../../components/ui/button';
import { NotaGradinite } from './NotaGradinite';

/**
 * Singura intrare laterala: „Ești profesor nou? / Înscrie-te".
 *
 * ⚠️ Pana pe 20.09 erau DOUA, cerute de client in sedinta din 18.09 (A2) — a doua era „Ai deja
 * cont (ai participat în edițiile trecute)? / Accesează", si ducea pe `/cod-de-acces`. Dar
 * intre timp formularul de logare a devenit UN SINGUR PAS (`LoginPage.tsx`: cere e-mailul si
 * cheama `POST /api/auth/otp/request`, apoi sare direct la verificare), iar `/cod-de-acces` a
 * ramas un ecran care cere din nou exact acelasi e-mail. Deci butonul ducea in acelasi loc ca
 * butonul principal, cu un pas in plus la mijloc. Sters pe 20.09, la cererea owner-ului,
 * oriunde aparea — inclusiv pe `HomePage`.
 *
 * Extrasa intr-o componenta pentru ca apare in DOUA locuri — pagina de intrare (`HomePage`) si
 * ecranul de logare (`LoginPage`) — si cele doua trebuie sa spuna acelasi lucru cu aceleasi
 * cuvinte. Duplicate, ar fi divergat la prima corectie de text.
 *
 * ⚠️ «Înscrie-te» duce pe `/profesor/inregistrare`, care sub `VITE_INREGISTRARE_COD`
 * randeaza wizardul cu cod; cu flagul oprit, formularul clasic. Componenta nu citeste
 * flagul: ruta e aceeasi in ambele cazuri, doar ecranul din spate difera.
 */
export function IntrariInscriere({ dezactivat = false }: { dezactivat?: boolean }) {
  const { PATHS, PAGES } = useRoutesProvider();
  const navigate = useNavigate();

  return (
    <div className="space-y-1.5">
      <p className="m-0 text-fluid-sm font-semibold text-dark">Ești profesor nou?</p>
      <Button
        type="button"
        variant="outline"
        size="lg"
        disabled={dezactivat}
        onClick={() => navigate(PATHS[PAGES.TEACHER_REGISTER])}
        className="w-full touch-target"
      >
        Înscrie-te
      </Button>
      <NotaGradinite className="pt-1.5" />
    </div>
  );
}
